export const irParaTopo = () => {
  document
    .getElementById("topo")
    .scrollIntoView({ block: "center", behavior: "instant" });
};
